/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ChildTransistorLocation } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TransistorEventServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param childTransistorLocation 
     */
    transistorEventControllerCreate0(childTransistorLocation: ChildTransistorLocation, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param childTransistorLocation 
     */
    transistorEventControllerCreate1(childTransistorLocation: ChildTransistorLocation, extraHttpRequestParams?: any): Observable<{}>;

}
